<div class="tw-flex tw-flex-col tw-h-full tw-overflow-y-auto tw-bg-gray-100" *ngIf="loading">
  <loading class="tw-flex-1 tw-self-center tw-justify-self-center"></loading>
</div>
<section class="tw-flex tw-flex-col tw-h-full" [ngClass]="{ 'tw-bg-teal-100': selectedPlan === 'advance' || selectedPlan === 'introductory', 'tw-bg-orange-100': selectedPlan === 'pro', 'tw-bg-blue-100': selectedPlan === 'assist'}" *ngIf="!loading">
  <section class="tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden tw-min-h-0">
    <section class="tw-bg-black">
      <section class="tw-relative tw-pt-[13px] tw-pb-[11px] tw-px-6 tw-mb-[10px]">
        <div class="tw-absolute tw-left-[34px] tw-top-3" (click)="back()">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
        </div>
        <p class="tw-font-body tw-text-white tw-text-400 tw-w-max tw-m-auto" i18n="@@chooseTreatmentPlan">Choose treatment plan</p>
      </section>
      <toolbar-tabs #toolbarTabs=""
                    (tabSelected)="tabChange($event)"
                    [data]="tabData"
                    [ngClass]="{'planInfo': true, 'tw-bg-black': tabData?.count === 3}">
        <tab1 class="tw-uppercase tw-font-bold">
          <span [ngClass]="{'tw-text-white tw-font-bold': tabData?.count === 4}">{{getVariantPrice(0)}}</span>
        </tab1>
        <tab2 class="tw-uppercase tw-font-bold">
          <span [ngClass]="{'tw-text-white': tabData?.count === 4}">{{getVariantPrice(1)}}</span>
        </tab2>
        <tab3 *ngIf="tabData?.count >= 3" class="tw-uppercase tw-font-bold" [ngClass]="{'tw-px-3': tabData?.count === 3}">
          <span [ngClass]="{'tw-text-white': tabData?.count === 4}">{{getVariantPrice(2)}}</span>
        </tab3>
        <tab4 *ngIf="tabData?.count === 4" class="tw-uppercase tw-font-bold">
          <span class="tw-text-white">{{getVariantPrice(3)}}</span>
        </tab4>
      </toolbar-tabs>
    </section>
    <swiper #planSwiper [config]="planSwiperConfig" (slideChange)="onPlanSlideChange($event)">
      <ng-template *ngFor="let plan of activePlans; let slideIndex = index" swiperSlide>
        <section class="tw-w-full">
          <section class="tw-w-full">
            <p class="tw-font-lexend tw-font-semibold tw-text-gray-800 tw-pt-3 tw-pl-4" i18n="@@yourTreatmentPlanIncludes">Your&nbsp;<span>₹{{getVariantPrice(slideIndex)}}</span>&nbsp;treatment plan includes</p>
            <section class="tw-p-4 tw-pr-7 tw-bg-white tw-flex tw-flex-row tw-items-center tw-gap-2 tw-mx-4 tw-my-2 tw-shadow-z4 tw-rounded-2" *ngFor="let item of getPlanInfoByPlan(plan).items; let i = index;">
              @if (item.id === planInfoItemId.PRODUCTS) {
                <div class="tw-w-16 tw-h-16 tw-rounded-full tw-overflow-hidden tw-flex-none">
                  <img class="tw-w-full tw-h-full tw-scale-[1.4]" style="object-fit: contain; object-position: center;" [src]="planCoverImages[slideIndex]" alt="regimenCover" />
                </div>
              } @else if (item.id === planInfoItemId.DEDICATED_DOCTOR || item.id === planInfoItemId.ONE_ON_ONE_DOCTOR) {
                <div class="tw-relative tw-w-16 tw-h-16 tw-rounded-full tw-overflow-hidden tw-bg-gray-100">
                  <img class="tw-block tw-absolute tw-top-[5px] tw-left-[5px] tw-w-[52px] tw-h-16 tw-rounded-full" [src]="doctorImageUrl" alt="doctorThumbnail" />
                </div>
              } @else {
                <img class="tw-flex-none tw-block tw-w-16 tw-object-contain tw-h-16 tw-rounded-full" [src]="item.imageUrl" alt="item" />
              }
              <div class="tw-flex-1">
                @if (item.id === planInfoItemId.PRODUCTS) {
                  <h2 class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-900 tw-mb-0.5">
                    <span i18n="@@PRODUCT_TREATMENT_KIT_WITH_COUNT">{{ getProductsCountForIndex(slideIndex) }} product Treatment Kit</span>
                  </h2>
                  <p class="tw-font-body tw-text-200 tw-text-gray-500">
                    @if (regimenClass === appConfig.Shared.Regimen.Class.HAIR) {
                      <span i18n="@@CUSTOMISED_KIT_PRODUCTS_WITH_COUNT_HAIR">A customised kit of {{ getProductsCountForIndex(slideIndex) }} products for your hair concerns.</span>
                    } @else {
                      <span i18n="@@CUSTOMISED_KIT_PRODUCTS_WITH_COUNT">A customised kit of {{ getProductsCountForIndex(slideIndex) }} products for your skin concerns.</span>
                    }
                  </p>
                } @else {
                  <h2 class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-900 tw-mb-0.5">
                    {{ item.title }}
                  </h2>
                  <p class="tw-font-body tw-text-200 tw-text-gray-500">
                    {{ item.description }}
                  </p>
                }
              </div>
            </section>
          </section>
          <section class="tw-flex tw-items-center tw-justify-center tw-font-body tw-text-200 tw-text-black tw-mt-2 tw-mx-4 tw-py-2 tw-px-[9px]">
            <p class="tw-w-[98px] tw-text-left" i18n="@@100%Effective">100% Effective</p>
            <div class="tw-flex-none tw-border-solid tw-border-l tw-border-gray-900 tw-opacity-20 tw-self-stretch"></div>
            <p class="tw-flex-1 tw-text-center" i18n="@@clinicallyTested">Clinically Tested</p>
            <div class="tw-flex-none tw-border-solid tw-border-l tw-border-gray-900 tw-opacity-20 tw-self-stretch"></div>
            <p class="tw-w-[90px] tw-text-right" i18n="@@freeDelivery">Free Delivery</p>
          </section>
        </section>
      </ng-template>
    </swiper>
    <div style="min-height: calc(env(safe-area-inset-bottom, 0px) + 110px);"></div>
  </section>
  <div class="tw-fixed tw-inset-x-0 tw-bottom-0 tw-z-10 tw-overflow-visible">
    @if (showPlanSelectedToast) {
      <div class="tw-absolute tw-left-0 tw-right-0 tw-flex tw-items-center tw-justify-center tw-py-2.5 tw-px-4 tw-overflow-hidden tw-pointer-events-none"
           [class]="isToastDismissing ? 'plan-toast-exit' : 'plan-toast-enter'"
           style="border-radius: 8px 8px 0 0; bottom: 100%; z-index: 0;"
           (animationend)="onToastAnimationEnd()">
        <img class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover" src="https://cdn.cureskin.com/app/img/yellow_gradient.gif" alt="" />
        <span class="tw-relative tw-font-lexend tw-font-bold tw-text-300 tw-text-white" i18n="@@yourPlanIsChangedTo">Your plan is changed to ₹{{toastPlanPrice}} plan</span>
      </div>
    }
    <div class="tw-relative tw-z-10 tw-bg-white tw-p-4">
      @if (isSelectedVariantIdMatchingPlan) {
        <button class="tw-w-full tw-h-12 tw-relative tw-text-gray-50 tw-text-[18px] tw-capitalize tw-p-4 shine loop tw-bg-teal-600 tw-overflow-visible tw-mb-2 tw-rounded-3 tw-border-none"
          (click)="buyRegimen()">
          <div class="tw-absolute tw-flex tw-items-center tw-justify-center -tw-top-2 tw-left-4 tw-text-orange-400">
            <svg class="tw-w-16 tw-h-16 tw-relative tw-animate-spin_slow discount-badge-shadow"
              xmlns="http://www.w3.org/2000/svg"
              width="64.443"
              height="67.447"
              viewBox="0 0 64.443 67.447">
                <path id="Path_23051"
                  data-name="Path 23051"
                  d="M87.025,208.059,79.5,203.146l-2.347-8.676a3.039,3.039,0,0,0-3.088-2.243l-8.976.449-7-5.639a3.042,3.042,0,0,0-3.817,0l-7,5.639-8.975-.449a3.031,3.031,0,0,0-3.088,2.243l-2.347,8.676-7.525,4.912a3.042,3.042,0,0,0-1.179,3.63l3.2,8.4-3.2,8.4a3.042,3.042,0,0,0,1.179,3.63l7.525,4.913,2.347,8.675a3.034,3.034,0,0,0,3.088,2.243l8.975-.449,7,5.639a3.041,3.041,0,0,0,3.817,0l7-5.639,8.976.449a3.036,3.036,0,0,0,3.088-2.243l2.347-8.675,7.525-4.913a3.042,3.042,0,0,0,1.179-3.63l-3.2-8.4,3.2-8.4A3.042,3.042,0,0,0,87.025,208.059Z"
                  transform="translate(-23.961 -186.363)"
                  fill="#D66736"></path>
              </svg>
              <span class="tw-absolute tw-font-body tw-text-500 tw-text-white tw-z-20 tw-font-bold tw-leading-none">{{regimenDiscountBasedOnSelectedPlan}}%
                <br /><span class="tw-font-medium">Off</span>
              </span>
          </div>
          <span class="tw-ml-10 tw-font-lexend tw-font-bold tw-text-400 tw-leading-[20px]">
            <span class="tw-text-400" i18n="@@buyNow">Buy Now</span>
            <span> &#64;</span>
            <span class="tw-text-200 tw-line-through">₹{{regimenMrpBasedOnSelectedPlan}}</span>
            <span>₹{{regimenPriceBasedOnSelectedPlan}}</span>
          </span>
        </button>
      } @else {
        <button csButton="outlined" type="button" class="tw-w-full" [loading]="updatingPlan" (click)="updateRegimenWithSelectedPlan(selectedPlan)">
          <span class="tw-text-300 tw-font-lexend tw-font-bold" i18n="@@selectThisPlan">Select This Plan</span>
        </button>
      }
    </div>
  </div>
</section>
